import AsideWithTabs from "./AsideWithTabs";
export default AsideWithTabs;